import { LoadingOverlay, Modal } from '@mantine/core';
import useUpdateTagMetadata from '../../../hooks/tags/useUpdateTagMetadata.ts';
import MutateTagForm, {
  MutateTagFormValues,
} from '../../ui/tags/MutateTagForm.tsx';
import { UpdateTagMetadataRequest } from '../../../api/requests/tag-request.ts';
import { notifyError } from '../../../utils/NotifyError.tsx';
import useTag from '../../../hooks/tags/useTag.ts';
import { useMutation } from '@tanstack/react-query';
import { ErrorResponse } from '../../../api/responses/error-response.ts';

interface UpdateTagMetadataModalProps {
  opened: boolean;
  onClose: () => void;
  tagId: string;
  onSuccess?: () => void;
}

const UpdateTagMetadataModal = ({
  opened,
  onClose,
  tagId,
  onSuccess,
}: UpdateTagMetadataModalProps) => {
  const { data: tag, isLoading: isTagLoading } = useTag(tagId);

  const { mutateAsync: updateTagMetadata } = useUpdateTagMetadata();

  const { mutate: handleSubmit, isPending: isUpdateTagMetadataPending } =
    useMutation<void, ErrorResponse, MutateTagFormValues>({
      mutationFn: async (formValues) => {
        const updateTagMetadataRequest: UpdateTagMetadataRequest = {
          tagId: tag.id,
          name: tag.name.trim(),
          description: formValues.description,
        };

        await updateTagMetadata(updateTagMetadataRequest);
      },
      onSuccess: () => {
        onSuccess?.();
      },
      onError: (error) => {
        notifyError('更新標籤失敗', error.message);
      },
    });

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="更新標籤"
      centered
      closeOnClickOutside={false}
      styles={{ title: { fontWeight: 700, fontSize: 16 } }}
    >
      {isTagLoading ? (
        <LoadingOverlay visible />
      ) : (
        <MutateTagForm
          initialValues={{
            name: tag.name,
            description: tag.description,
          }}
          onSubmit={handleSubmit}
          onCancel={onClose}
          isSubmitting={isUpdateTagMetadataPending}
          isUpdating={true}
          submitButtonText={'更新'}
        />
      )}
    </Modal>
  );
};

export { UpdateTagMetadataModal };
